// Format số tiền thành định dạng VNĐ
export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: 'VND',
  }).format(amount);
};

// Format ngày tháng
export const formatDate = (date, format = 'dd/MM/yyyy') => {
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');
  const seconds = String(d.getSeconds()).padStart(2, '0');

  const formats = {
    'dd/MM/yyyy': `${day}/${month}/${year}`,
    'MM/dd/yyyy': `${month}/${day}/${year}`,
    'yyyy-MM-dd': `${year}-${month}-${day}`,
    'dd/MM/yyyy HH:mm': `${day}/${month}/${year} ${hours}:${minutes}`,
    'dd/MM/yyyy HH:mm:ss': `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`,
  };

  return formats[format] || formats['dd/MM/yyyy'];
};

// Truncate text
export const truncateText = (text, maxLength = 50) => {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};

// Validate email
export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// Validate phone number (Vietnam)
export const isValidPhoneNumber = (phone) => {
  const phoneRegex = /(84|0[3|5|7|8|9])+([0-9]{8})\b/;
  return phoneRegex.test(phone);
};

// Debounce function
export const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

// Get initials from name
export const getInitials = (name) => {
  if (!name) return '';
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .substring(0, 2);
};

// Generate random color for avatar
export const generateColorFromName = (name) => {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const color = Math.floor(Math.abs((Math.sin(hash) * 16777215) % 1) * 16777215);
  return '#' + color.toString(16).padStart(6, '0');
};

// Copy to clipboard
export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (err) {
    console.error('Failed to copy:', err);
    return false;
  }
};

// File size formatter
export const formatFileSize = (bytes) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
};

/**
 * Lấy URL ảnh đại diện (Xử lý cả link local và Cloudinary)
 * @param {string} avatarPath - Đường dẫn ảnh lưu trong DB
 * @returns {string} - URL hoàn chỉnh để hiển thị
 */
export const getAvatarUrl = (avatarPath) => {
  if (!avatarPath) return '';
  
  // Nếu là link tuyệt đối (http/https) hoặc base64 -> Trả về luôn
  if (/^(https?:)?\/\//i.test(avatarPath) || avatarPath.startsWith('data:')) {
    return avatarPath;
  }

  // Nếu là link local -> Thêm prefix API_UPLOADS_URL
  const baseUrl = (process.env.API_UPLOADS_URL || 'http://localhost:5000').replace(/\/+$/, '');
  const cleanPath = avatarPath.replace(/^\/+/, '');
  
  return `${baseUrl}/${cleanPath}`;
};
